import createReduxPromiseActionType from "utils/create_redux_promise_action_type";

const actionTypes = {};
createReduxPromiseActionType(actionTypes, "CLAUSE_BANK_FETCH");

export default actionTypes;
